class User{
  store
  date;
  space;
  user;

  constructor(store,date, space, user){
    this.store = store;
    this.date = date;
    this.space = space;
    this.user = user;
  }

  static fromJSON(store, json) {
    const { date, space, user } = json;
    return new User(store, date, space, user );
  }

}
export default User;
